import {
    Directive,
    ElementRef,
} from '@angular/core';

/// --- RELEVANT LINKS:
/// https://gist.github.com/runspired/b9fdf1fa74fc9fb4554418dea35718fe
/// https://stackoverflow.com/questions/40200130/how-to-disable-chrome-to-autofill-username-email-password
/// https://bugs.chromium.org/p/chromium/issues/detail?id=468153
/// ---
@Directive({
    selector: '[uiPreventAutofill]',
})
export class PreventAutofillDirective {
    constructor(el: ElementRef) {
        if (
            !(el.nativeElement instanceof HTMLFormElement) &&
            !(el.nativeElement instanceof HTMLInputElement)
        ) {
            throw new Error('Directive can only be used on form, password and username input elements.');
        }

        if (el.nativeElement instanceof HTMLFormElement) {
            const form = el.nativeElement as HTMLFormElement;
            form.insertBefore(this._fakeInputFor('name'), form.firstChild);
            form.insertBefore(this._fakeInputFor('password'), form.firstChild);
        } else {
            const input = el.nativeElement;
            if (input.type === 'password') {
                input.autocomplete = 'new-password';
            }

            if (input.type === 'text') {
                input.autocomplete = 'nope';
            }
        }
    }

    private _fakeInputFor(type: 'password' | 'name'): HTMLInputElement {
        const input = document.createElement('input');
        input.autocomplete = 'false';
        input.type = type === 'password' ? type : 'text';
        input.name = `fake${type}remembered`;
        input.style.display = 'none';
        return input;
    }
}
